import { USER_ROLE } from '@skyrise-eng/types';
import type { BaseColumn } from './UserSettings.types';
import { RATE_BUILDER_ROLE } from '@/constants/roles';

export const RoleDetails: Record<USER_ROLE, { name: string; className: string }> = {
  [USER_ROLE.ADMIN]: { name: 'Admin', className: 'admin' },
  [USER_ROLE.SUPER_ADMIN]: { name: 'Super Admin', className: 'super-admin' },
  [USER_ROLE.TRADER]: { name: 'Trader', className: 'trader' },
  [USER_ROLE.LEAD_TRADER]: { name: 'Lead Trader', className: 'lead-trader' },
  [USER_ROLE.ACCOUNT_MANAGER]: { name: 'Account Manager', className: 'account-manager' },
  [USER_ROLE.FINANCE_MANAGER]: { name: 'Finance Manager', className: 'finance-manager' },
  [USER_ROLE.CUSTOMER]: { name: 'Customer', className: 'customer' },
  [RATE_BUILDER_ROLE]: { name: 'Rate Builder only', className: 'rate-builder' }
};

export enum Column {
  NAME = 'name',
  EMAIL = 'email',
  ROLE = 'role',
  ACTIONS = 'actions'
}

export const COLUMNS: Record<Column, BaseColumn> = {
  [Column.NAME]: {
    i18nKey: 'name',
    dataIndex: 'name',
    key: 'name'
  },
  [Column.EMAIL]: {
    i18nKey: 'email',
    dataIndex: 'email',
    key: 'email'
  },
  [Column.ROLE]: {
    i18nKey: 'role',
    dataIndex: 'role',
    key: 'role'
  },
  [Column.ACTIONS]: {
    i18nKey: 'actions',
    dataIndex: 'actions',
    key: 'actions',
    fixed: 'right',
    className: 'actions'
  }
};
